import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import identity from './identity'
import registerRoutes from './registerRoutes'

Vue.use(Router)

const pages = {
  '/home': {
    meta: {
      id: 'home',
    },
    component: () => import('@/views/home/index'),
  },
  '/ibreport': {
    meta: {
      id: 'report',
    },
    component: () => import('@/views/ibReport/index'),
  },
  '/iblevel': {
    meta: {
      id: 'ibLevel',
    },
    component: () => import('@/views/IbLevel'),
  },
  '/ibaccounts': {
    meta: {
      id: 'account',
    },
    component: () => import('@/views/IbAccounts'),
  },
  '/pendingaccounts': {
    meta: {
      id: 'account',
    },
    component: () => import('@/views/PendingAccounts'),
  },
  '/leads': {
    meta: {
      id: 'account',
    },
    component: () => import('@/views/Leads'),
  },
  '/allretailaccounts': {
    meta: {
      id: 'account',
    },
    component: () => import('@/views/AllRetailAccounts'),
  },
  '/settings': {
    meta: {
      id: 'ibProfile',
    },
    component: () => import('@/views/profile'),
  },
  '/contactUs': {
    meta: {
      id: 'contactUs',
    },
    component: () => import('@/views/ContactUs'),
  },
  '/rebatePaymentHistory': {
    meta: {
      id: 'payHistory',
    },
    component: () => import('@/views/RebatePaymentHistory'),
  },
  '/referralLinks': {
    meta: {
      id: 'refLinks',
    },
    component: () => import('@/views/referralLinks/ReferralLinks'),
  },
}

let routes = [
  {
    path: '',
    component: () => import('@/views/Layout'),
    children: [
      {
        name: '/',
        path: '/',
        component: () => import('@/views/home/index'),
      },
      ...registerRoutes,
      {
        path: '/rebateTransfer',
        name: '/rebateTransfer',
        component: () => import('@/views/RebateTransfer'),
        beforeEnter: async (to, from, next) => {
          if (!store.getters['common/operateAmountPermission']) {
            next('/')
          } else {
            next()
          }
        },
      },
      {
        path: '/rebateWithdraw',
        name: '/rebateWithdraw',
        component: () => {
          const isUsePcs = store.state.payment.isUsePcs
          return isUsePcs ? import('@/views/RebateWithdrawV2') : import('@/views/RebateWithdraw')
        },
        beforeEnter: async (to, from, next) => {
          if (!store.getters['common/operateAmountPermission']) {
            next('/')
          } else {
            const access = await store.dispatch('payment/actionSetIsUsePcs')
            if (access) next()
          }
        },
      },
      ...Object.keys(pages).map(b => {
        return {
          id: pages[b].id,
          name: b,
          path: b,
          meta: pages[b].meta,
          component: pages[b].component,
          beforeEnter: pages[b].beforeEnter,
        }
      }),
    ],
  },
]

const router = new Router({
  mode: 'history',
  routes: [
    ...routes,
    {
      path: '',
      component: () => import('@/views/Layout'),
      children: [
        {
          name: '404',
          path: '*',
          component: () => import('@/views/404'),
        },
      ],
    },
  ],
})

export default router
identity.authorize()
